<div class="container col-md-12">
  <div class="">
    <div class="d-flex justify-content-between mb-5">
      <h1 class="page col-md-6 mb-4">Orders Tracking</h1>
      <div class="d-flex">
        
        <button  class="bg-danger btn btn-sm ms-2"   (click)="resetFilters()"  > Clear Filters</button>
         <button  class="bg-primary btn btn-sm  ms-2"    (click)="downloadOrder()"  > Download</button>
      </div>
    </div>
  </div>

  <div class="d-flex justify-content-between col-md-12 align-items-center">
       <div>
          <div class="d-flex justify-content-between laptop">
          <div class="border text-whhite d-flex justify-content-end page-top">
              <mat-paginator (page)="paginatorDropdown($event)" [pageSizeOptions]="[20, 50, 100]"></mat-paginator>
          </div>
        </div>

        <div class="justify-content-center mt-5 text-center mobile">
          <div class="border text-whhite d-flex justify-content-center page-top mt-2">
              <mat-paginator (page)="paginatorDropdown($event)" [pageSizeOptions]="[20, 50, 100]"></mat-paginator>
          </div>
        </div>

       </div >

       <div class='gap-2'>
        <!-- <mat-form-field appearance="outline" class="me-3">
          <mat-label>Enter a date range</mat-label>
          <mat-date-range-input [rangePicker]="picker" [min]="minDate" [max]="maxDate">
            <input matStartDate [formControl]="startDateForm" placeholder="Start date"  >
            <input matEndDate [formControl]="endDateForm" placeholder="End date" >
          </mat-date-range-input>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker #picker>
            <mat-datepicker-actions>
              <button class="btn btn-sm bg-danger me-2"  matDatepickerCancel  (click)="closedDateFilter('third')">  Cancel</button>
              <button class="btn btn-sm bg-success"  matDatepickerApply  (click)="closedFilter()"> Apply</button>
            </mat-datepicker-actions>
          </mat-date-range-picker>
        </mat-form-field> -->

        <mat-form-field appearance="outline">
          <mat-label>Search...</mat-label>
          <input matInput [formControl]="searchControlForm" (keydown.enter)="searchValue($event.target.value)"  placeholder="Search...."  >
        </mat-form-field>
      </div>
  </div>

  <div class="row d-flex justify-content-center p-4">
    <div class="card-body" style="background-color: transparent">
      <div class="material-datatables">
        <div class="position-relative overflow-auto">
          <table class="table table-no-bordered table-hover"  mat-table  [dataSource]="customers" >
            <!-- ID Column -->
            <ng-container [matColumnDef]="tableheader"  *ngFor="let tableheader of displayedColumns; index as i"  >
              <th   mat-header-cell   *matHeaderCellDef  class="text-center text-primary text-bold"  style="width: auto !important; white-space: nowrap">
                <span>{{ headerData[tableheader] }}</span>

                <span  *ngIf="headerData[tableheader] == 'Status'"  class="filter-icon" style="white-space: nowrap; padding: 14px">
                  <i  class="fa fa-filter pl-2" (click)="selectStatus.open()" style="font-size: 10px; cursor: pointer" ></i>
                  <mat-select #selectStatus  [formControl]="statusForm"   >
                    <mat-option  *ngFor="let zone of statusData"  (click)="closedFilter()"  [value]="zone" >
                      {{ zone }}
                    </mat-option>
                  </mat-select>
                </span>

                <span  *ngIf="headerData[tableheader] == 'Courier Partner'"  class="filter-icon" style="white-space: nowrap; padding: 14px">
                  <i  class="fa fa-filter pl-2" (click)="selectCourier.open()" style="font-size: 10px; cursor: pointer" ></i>
                  <mat-select #selectCourier  [formControl]="courierPartnerForm"  style="  border: none;  background: none; -webkit-appearance: none;  -moz-appearance: none;  appearance: none;"  class="hide-arrow" >
                    <mat-option  *ngFor="let zone of ['Delhivery','DTDC']"  (click)="closedFilter()"  [value]="zone" >
                      {{ zone }}
                    </mat-option>
                  </mat-select>
                </span>

                <span  *ngIf="headerData[tableheader] == 'Attempt Status'"  class="filter-icon" style="white-space: nowrap; padding: 14px">
                  <i  class="fa fa-filter pl-2" (click)="selectAttemptStatus.open()" style="font-size: 10px; cursor: pointer" ></i>
                  <mat-select #selectAttemptStatus  [formControl]="attemptStatusForm"  style="  border: none;  background: none; -webkit-appearance: none;  -moz-appearance: none;  appearance: none;"  class="hide-arrow" >
                    <mat-option  *ngFor="let zone of ['First Attempt','Second Attempt','Third Attempt']"  (click)="closedFilter()"  [value]="zone" >
                      {{ zone }}
                    </mat-option>
                  </mat-select>
                </span>

                <span *ngIf="headerData[tableheader] == 'Order Date'" class="date-wrapper">
                  <span class="fa fa-calendar ms-2" (click)="orderDatePicker.open()"></span>
                  <mat-form-field class="hidden-datepicker">
                    <mat-date-range-input [rangePicker]="orderDatePicker" [min]="minDate" [max]="maxDate" >
                      <input matStartDate [formControl]="orderStartDateForm"  >
                      <input matEndDate [formControl]="orderEndDateForm"    >
                    </mat-date-range-input>
                    <mat-date-range-picker #orderDatePicker>
                      <mat-datepicker-actions>
                        <button class="btn btn-sm bg-danger me-2"  matDatepickerCancel  (click)="closedDateFilter('order')">  Cancel</button>
                        <button class="btn btn-sm bg-success"  matDatepickerApply  (click)="closedFilter()">Apply</button>
                      </mat-datepicker-actions>
                    </mat-date-range-picker>
                  </mat-form-field>
                  <!-- <mat-form-field class="hidden-datepicker">
                    <input matInput [matDatepicker]="datepicker" [formControl]="orderDateForm" [min]="minDate" [max]="maxDate" readonly>
                    <mat-datepicker #datepicker>
                      <mat-datepicker-actions>
                        <button class="btn btn-sm bg-danger me-2"  matDatepickerCancel  (click)="closedDateFilter('order')">  Cancel</button>
                        <button class="btn btn-sm bg-success"  matDatepickerApply  (click)="closedFilter()">  Apply</button>
                      </mat-datepicker-actions>
                    </mat-datepicker>
                  </mat-form-field> -->
                </span>

                <span *ngIf="headerData[tableheader] == 'First Attempt Date'" class="date-wrapper">
                  <span class="fa fa-calendar ms-2" (click)="datepickerFirst.open()"></span>
                  <mat-form-field class="hidden-datepicker">
                    <input matInput [matDatepicker]="datepickerFirst" [formControl]="firstAttemptDateForm" [min]="minDate" [max]="maxDate" readonly>
                    <mat-datepicker #datepickerFirst>
                      <mat-datepicker-actions>
                        <button class="btn btn-sm bg-danger me-2"  matDatepickerCancel  (click)="closedDateFilter('first')">  Cancel</button>
                        <button class="btn btn-sm bg-success"  matDatepickerApply  (click)="closedFilter()">  Apply</button>
                      </mat-datepicker-actions>
                    </mat-datepicker>
                  </mat-form-field>
                </span>

                <span *ngIf="headerData[tableheader] == 'Second Attempt Date'" class="date-wrapper">
                  <span class="fa fa-calendar ms-2" (click)="datepickerSecond.open()"></span>
                  <mat-form-field class="hidden-datepicker">
                    <input matInput [matDatepicker]="datepickerSecond" [formControl]="secondAttemptDateForm" [min]="minDate" [max]="maxDate" readonly>
                    <mat-datepicker #datepickerSecond>
                      <mat-datepicker-actions>
                        <button class="btn btn-sm bg-danger me-2"  matDatepickerCancel  (click)="closedDateFilter('second')">  Cancel</button>
                        <button class="btn btn-sm bg-success"  matDatepickerApply  (click)="closedFilter()">  Apply</button>
                      </mat-datepicker-actions>
                    </mat-datepicker>
                  </mat-form-field>
                </span>

                <span *ngIf="headerData[tableheader] == 'Third Attempt Date'" class="date-wrapper">
                  <span class="fa fa-calendar ms-2" (click)="datepickerThird.open()"></span>
                  <mat-form-field class="hidden-datepicker">
                    <input matInput [matDatepicker]="datepickerThird" [formControl]="thirdAttemptDateForm" [min]="minDate" [max]="maxDate" readonly>
                    <mat-datepicker #datepickerThird>
                      <mat-datepicker-actions>
                        <button class="btn btn-sm bg-danger me-2"  matDatepickerCancel  (click)="closedDateFilter('third')">  Cancel</button>
                        <button class="btn btn-sm bg-success"  matDatepickerApply  (click)="closedFilter()">  Apply</button>
                      </mat-datepicker-actions>
                    </mat-datepicker>
                  </mat-form-field>
                </span>

                <span *ngIf="headerData[tableheader] == 'Dispatch By Date'" class="date-wrapper">
                  <span class="fa fa-calendar ms-2 " (click)="dispatchByDate.open()"></span>
                  <mat-form-field class="hidden-datepicker">
                    <mat-date-range-input [rangePicker]="dispatchByDate" [min]="minDate" [max]="maxDate" >
                      <input matStartDate [formControl]="dispatchByDateStartForm"  >
                      <input matEndDate [formControl]="dispatchByDateEndForm"    >
                    </mat-date-range-input>
                    <mat-date-range-picker #dispatchByDate>
                      <mat-datepicker-actions>
                        <button class="btn btn-sm bg-danger me-2"  matDatepickerCancel  (click)="closedDateFilter('dispatch')">  Cancel</button>
                        <button class="btn btn-sm bg-success"  matDatepickerApply  (click)="closedFilter()">Apply</button>
                      </mat-datepicker-actions>
                    </mat-date-range-picker>
                  </mat-form-field>
                </span>

              </th>
              
               <ng-container *ngIf="tableheader == 'scan_details'" >
                    <td  mat-cell class="text-center align-middle"  style="white-space: nowrap; font-size: 12px" *matCellDef="let row; index as i">
                    <span class="fa fa-eye" (click)="openScanDetailsView(row)" > </span>
                    </td>
                </ng-container>

                <ng-container *ngIf="tableheader == 'instructions'" >
                  <td  mat-cell class="text-center align-middle"  style="white-space: nowrap; font-size: 12px" *matCellDef="let row; index as i">
                    <span class="" [matTooltip]="row.instructions"  >{{ row.instructions.toString().length > 20 ? row.instructions.slice(0,20) + '...' : row.instructions }} </span>
                  </td>
                </ng-container>

              <ng-container >
                <td  mat-cell class="text-center align-middle"  style="white-space: nowrap; font-size: 12px" *matCellDef="let row; index as i">
                  <span>{{ row[tableheader] }}</span>
                </td>
              </ng-container>

            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>
        </div>
      </div>
      <div class="border text-whhite d-flex justify-content-end page-bottom">
        <mat-paginator *ngIf="apiData.length!=0" (page)="syncPrimaryPaginator($event)" [pageSize]="paginator.pageSize" [pageIndex]="paginator.pageIndex" [length]="length" [pageSizeOptions]="paginator.pageSizeOptions"></mat-paginator>
        <!-- <mat-paginator  class="bg-transparent"  [hidden]="apiData?.length == 0"  [length]="fulllength"  [pageSizeOptions]="[10, 25, 50]"  [(pageSize)]="paginate.pageSize"  (page)="fetchData($event)"  ></mat-paginator> -->
      </div>

    </div>
  </div>
</div>



<ng-container *ngIf="showOverlay" id="overlay-container">
  <app-spinner [overlay]="true" id="loader"></app-spinner>
</ng-container>


<ng-template #overviewDetailsTemp let-modal>
    <div class="modal-content">

        <div class="modal-header">
            <h4 class="card-title mb-0 flex-grow-1">OverView</h4>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="btn-close" (click)="modal.dismiss('Cross click')"></button>
        </div>

        <div class="modal-body">
            <div class="mt-3">
                <table class="mt-3 w-100">
                    <thead class="col-md-12" style="background-color: #e6f2ff;">
                    <tr class="col-md-12 text-center">
                        <th class=" p-2" style="font-weight: bold !important; font-size: medium;">Sl No.</th>
                        <th class=" p-2" style="font-weight: bold !important; font-size: medium;">Scan</th>
                        <th class=" p-2" style="font-weight: bold !important; font-size: medium;">Hub Name</th>
                        <th class=" p-2" style="font-weight: bold !important; font-size: medium;">Status Code</th>
                        <th class=" p-2" style="font-weight: bold !important; font-size: medium;">Instructions</th>
                        <th class=" p-2" style="font-weight: bold !important; font-size: medium;">Scanned Location</th>
                        <th class=" p-2" style="font-weight: bold !important; font-size: medium;">Scanned At</th>
                    </tr>
                    </thead>

                    <tbody class="mt-1">
                    <tr class="text-center" *ngFor="let data of overViewDetails; let i = index" style="border-bottom: 1px solid #999;">
                        <td class=" p-2">{{ i + 1 }}</td>
                        <td class=" p-2" style="white-space: break-spaces;">{{ data.ScanDetail.Scan }}</td>
                        <td class=" p-2">{{ data.ScanDetail.hub_name}}</td>
                        <td class=" p-2">{{ data.ScanDetail.Statuscode }}</td>
                        <td class=" p-2">{{ data.ScanDetail.Instructions }}</td>
                        <td class=" p-2">{{ data.ScanDetail.ScannedLocation }}</td>
                        <td class=" p-2">{{ data.ScanDetail.ScanDateTime }}</td>
                    </tr>
                    </tbody>
                </table>
                </div>
            <div class="d-flex gap-2 justify-content-center mt-4 mb-2">
                <button type="button" class="btn w-sm btn-danger" (click)="modalClose()" id="deleteRecord-close">Close</button>
            </div>
        </div>
    </div>
    <ng-container *ngIf="showOverlay" id="overlay-container">
        <app-spinner [overlay]="true" id="loader"></app-spinner>
    </ng-container>
</ng-template>